export const GET_MENU_LIST = "GET_MENU_LIST";
